import DateTimeEditor from './DateTimeEditor.vue'
export default {
  install: function (Vue) {
    Vue.component('date-time-editor', DateTimeEditor)
  }
}